/**
 * Turning Google's error codes into something a listener can act on.
 *
 * Almost every failure here is a setup mistake rather than a bug, so the
 * messages say what to go and change.
 */

export function describeAuthError(code: string | undefined): string {
  switch (code) {
    case 'popup_closed':
    case 'popup_closed_by_user':
      return 'Sign-in window was closed before finishing.';
    case 'popup_failed_to_open':
      return 'The sign-in popup was blocked. Allow popups for this site and try again.';
    case 'access_denied':
      return 'Access was declined on the Google consent screen.';
    case 'idpiframe_initialization_failed':
      return 'Google could not start sign-in. Check that this origin is listed in your OAuth client.';
    default:
      return code ? `Google sign-in failed (${code}).` : 'Google sign-in failed.';
  }
}

export function describeApiError(status: number, detail = ''): string {
  if (status === 403 && /quota/i.test(detail)) {
    return 'YouTube API daily quota exceeded. It resets at midnight Pacific time.';
  }
  if (status === 403 && /not been used|disabled/i.test(detail)) {
    return 'YouTube Data API v3 is not enabled for this project yet. Enable it in Google Cloud Console.';
  }
  if (status === 403) return `YouTube refused the request. ${detail}`;
  if (status === 400 && /API key not valid/i.test(detail)) return 'That API key is not valid.';
  if (status === 401) return 'Your session expired. Sign in again.';
  if (status === 404) return 'That playlist or video no longer exists.';
  return detail || `YouTube request failed (${status}).`;
}
